import connectToStores from 'alt-utils/lib/connectToStores'
import { SearchConsoleActions } from 'actions'
import { SearchConsoleStore } from 'stores'
import { SearchConsoleComplex, SearchConsoleComplexCompact } from 'components'

@connectToStores
export default class SearchConsoleContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static getStores() {
    return [
      SearchConsoleStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...SearchConsoleStore.getState()
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      fetchingSearchAnalyticsQuery: true,
      searchAnalyticsQueryError: null,
      settingUpSearchConsole: false,
    }
  }

  isLegacySearchConsoleUser() {
    return this.context.currentUser.googleUserEmail &&
           !!this.context.currentUser.searchConsoleSite
  }

  componentWillMount() {
    if (!this.isLegacySearchConsoleUser()) {
      SearchConsoleActions.fetchStatus()
    }
  }

  render() {
    const SearchConsolePanel = this.props.compact ? SearchConsoleComplexCompact : SearchConsoleComplex

    return (
      <SearchConsolePanel
        consoleStatus = {this.props.consoleStatus}
        consoleSetupError = {this.props.consoleSetupError}
        legacyConsoleUser = {this.isLegacySearchConsoleUser()}
        searchAnalyticsQuery = {this.props.searchAnalyticsQuery}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/SearchConsoleContainer.js